import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';

export default function dayjsConfig() {
  dayjs.extend(objectSupport);
}
